import { render, staticRenderFns } from "./VTooltipIcon.vue?vue&type=template&id=adb99d46"
import script from "./VTooltipIcon.vue?vue&type=script&lang=js"
export * from "./VTooltipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports